<template>
  <div class="toggle" :class="{ active: isActive }" @click="toggle">
    <div class="toggle-handle"></div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'Toggle-Button',
  props: {
    toggleActive: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, context) {
    const isActive = ref(false);

    if (props) {
      isActive.value = props.toggleActive;
    }

    const toggle = () => {
      isActive.value = !isActive.value;
      context.emit('toggleSelected', isActive.value);
    };

    return {
      isActive,
      toggle,
    };
  },
};
</script>

<style scoped>
.toggle {
  width: 50px;
  height: 30px;
  background-color: #ddd;
  border-radius: 15px;
  cursor: pointer;
  display: flex;
}

.toggle-handle {
  width: 26px;
  height: 26px;
  background-color: #777;
  border-radius: 50%;
  margin: 2px;
  transition: transform 0.3s;
}

.toggle.active .toggle-handle {
  transform: translateX(20px);
}

.light-theme .toggle.active .toggle-handle {
  /* background-color: #004751; */
  background-color: #0a52d8;
}

.dark-theme .toggle.active .toggle-handle {
  background: linear-gradient(to top, #004751 5%, #137b89 95%);
}
</style>
